const resolver = require('./resolver');
const noTrack = require('./noTrack');
module.exports = {
  getWriteKey: resolver,
  getNoTrackWriteKey: noTrack
};